setWrappedQueryRef